
























































import httpApi from "@/API/Tenant/Weixin";
import { getCookie } from "@/JS/cookie"; //使用getCookie方法
import Bus from "@/JS/Bus";
import { Component, Provide, Vue, Watch, Prop } from "vue-property-decorator";
@Component({
  components: {}
})
export default class extends Vue {
  @Provide() selectTempIndex: number = -1;
  @Prop() private propWxTemplateList: any;
  @Provide() private wxTemplateList:any = '';
  @Provide() private loading = false;
  @Provide() private templateCount = 0;
  @Provide() private GetAppData: any = {}; //取应用号信息
  @Provide() countOthe = 0;
  async created() {
    if(this.propWxTemplateList){
      this.wxTemplateList = this.propWxTemplateList;
    }else{
      this.wxTemplateList = JSON.parse(sessionStorage.getItem('wxTemplateList') as any);
    }
    let Aid = getCookie("Aid");
    let TenantID = getCookie("TenantID");
    this.GetAppData = {
      Aid: Aid,
      TenantID: TenantID
    };
    var that = this;
    Bus.$off("switchAccountFn");
    Bus.$on("switchAccountFn", (obj: any) => {
      //that.$router.push("/tenants/tenantsView/wx-message_ModelTable");
      //location.href='/tenants/tenantsView/wx-message_ModelTable'
      that.GetAppData.Aid = obj.Aid;
      that.$emit("cancelData");
      that.backStep("messageList");
      // that.loadGetMessageTemplateWeiXin();
    });
    this.countOthe = 25 - this.propWxTemplateList.length;
    if (this.countOthe < 0) this.countOthe = 0;
  }
  //  监听公众号类型
  get tencentCode() {
    return this.$store.state.TencentInfoStore.typeCode;
  }
  @Watch("tencentCode", { immediate: false, deep: true })
  ontencentCode(val: string, oldVal: string) {
    // console.log("监听公众号类型: ");
    //console.log(val);
    //console.log(oldVal);
    this.$emit("cancelData");
    this.backStep("messageList");
  }
  //同步微信模板保存
  async SaveMessageTemplateWeiXin() {
    let params: any = {
      Input: [
        {
          Name: "aid",
          Value: this.GetAppData.Aid //消息模板类型
        }
      ]
    };
    this.loading = true;
    //console.log(params);
    var res: any = await httpApi.SaveMessageTemplateWeiXin(params);
    this.loading = false;
    if (res.ErrorCode == 0) {
      this.$message.success("同步成功！");
      this.$emit("loadGetMessageTemplateWeiXin");
      // this.loadGetMessageTemplateWeiXin();
    } else {
      this.$message.error("同步失败：" + res.ErrorMessage);
    }
  }

  selectTem(clickIndex: number) {
    this.selectTempIndex = clickIndex;
  }
  nextStep(pageElement: string) {
    if (this.selectTempIndex != -1) { 
      this.$emit("pageEl", [pageElement, this.selectTempIndex]);
    } else {
      this.$message({
        type: "info",
        message: "请选择需要创建的消息模板。"
      });
      return false;
    }
  }
  backStep(pageElement: string) {
    this.$emit("pageEl", [pageElement, -1]);
  }
}
